import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [showBanner, setShowBanner] = useState(true);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="header">
      {/* 顶部公告栏 */}
      {showBanner && (
        <div className="header-banner">
          <div className="banner-content">
            <p>
              <strong>FREE SHIPPING</strong> on orders over $249 for Australian
              deliveries (otherwise $8.95). All overseas orders from $27.50.{" "}
              <button
                className="dismiss-btn"
                onClick={() => setShowBanner(false)}
              >
                Dismiss
              </button>
            </p>
          </div>
        </div>
      )}

      {/* 主 Header 区域 */}
      <div className="header-main">
        <div className="header-container">
          {/* Logo */}
          <Link to="/" className="header-logo" onClick={toTop}>
            <h1>
              Emeline
              <br />
              PUBLICATIONS
            </h1>
          </Link>

          {/* 购物车 */}
          <Link to="/cart" className="header-cart" onClick={toTop}>
            CART / {cartItems.length}
          </Link>
        </div>
      </div>

      {/* 导航栏 */}
      <nav className="header-nav">
        <div className="nav-container">
          <ul className="nav-menu">
            <li className="nav-item dropdown">
              <Link to="/shop" onClick={toTop}>
                Online Store – Buy Now
              </Link>
            </li>
            <li className="nav-item dropdown">
              <Link to="/contact" onClick={toTop}>
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" onClick={toTop}>
                About
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
